import CertificateDetails from "./CertificateDetails";

export default CertificateDetails;
